import FBHeartAttack from "./container/FBHeartAttackLanding";

export default FBHeartAttack;
